var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('VJsoneditor',{ref:"jsonEditor",attrs:{"height":"600px","options":_vm.options,"plus":false},on:{"hook:mounted":_vm.onCreateEditor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }